/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface OAuthAppClientResponse { 
    /**
     * List of org Ids which are to be allowed for this app.
     */
    allowed_orgs?: Array<string>;
    /**
     * Client Id for the related oauth app.
     */
    client_id?: string;
    /**
     * Secret key for the oauth app client credentials.
     */
    client_secret?: string;
    default_redirect_uri?: string;
    /**
     * List of redirect URIs for app.
     */
    redirect_uris?: Array<string>;
}

